function post(uri, data, callback) {
    if (typeof data !== 'object') {
        data = {data: data};
    }
    let fr = fetch(uri, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((data) => {
        let contentType = data.headers.get('Content-Type');
        let dataCopy = data.clone();

        if (data.status === 200) {
            if (contentType.toLowerCase() === 'application/json') {
                data.json().then((json) => {
                    if (typeof callback === 'function') callback(json);
                }).catch((data2) => {
                    console.error("🚨 SyntaxError Not Json Format " + data2 + '\n', data.url, data);
                    dataCopy.text().then(console.log);
                })
            } else {
                data.text().then((str) => {
                    if (typeof callback === 'function') callback(str);
                })

            }

        }
    })


}

if (typeof window.$ === "undefined") {
    window.$ = {post};
} else {
    window.$.post = post;
}

let tags = {
    pink: (t, v) => {
        console.log(
            `%c ${t} %c ${v} %c`,
            'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
            'background:#d81b60 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
            'background:transparent'
        );
    },
    red: (t, v) => {
        console.log(
            `%c ${t} %c ${v} %c`,
            'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
            'background:#bf360c ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
            'background:transparent'
        );
    },
    green: (t, v) => {
        console.log(
            `%c ${t} %c ${v} %c`,
            'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
            'background:#7cb342 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
            'background:transparent'
        );
    },
    blue: (t, v) => {
        console.log(
            `%c ${t} %c ${v} %c`,
            'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
            'background:#01579b ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
            'background:transparent'
        );

    }
}
window.tags = tags;

function debounce(callback, delay) {
    var timer;
    return function () {
        var args = arguments;
        var context = this;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, delay)
    }
}

window.debounce = tags;
